import { render, staticRenderFns } from "./widgetBarchart.vue?vue&type=template&id=649ece5c&scoped=true&"
import script from "./widgetBarchart.vue?vue&type=script&lang=js&"
export * from "./widgetBarchart.vue?vue&type=script&lang=js&"
import style0 from "./widgetBarchart.vue?vue&type=style&index=0&id=649ece5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ece5c",
  null
  
)

export default component.exports